<template>
  <!-- <div v-if="order" style="background: #eee;"> -->
    
    <!-- <div > -->

      <ScrollerHandler style="height: calc(100vh - 72px); width: 100%;" class="pt-1" v-if="order && Object.keys($store.getters.status_rule_obj).length">
        <template #prepend>
          <v-banner :class="status_rules[orderStatus].color" rounded dark > 
            <div class="d-flex align-center">
              <v-icon v-if="order.order_type == 'DELIVERY'" large class="mr-3">mdi-truck-fast</v-icon>
              <v-icon v-else large class="mr-3">mdi-food</v-icon>
              <T class="mr-1">Заказ</T>
              #{{ orderId }} 
              <v-spacer></v-spacer> 
                <Buttons :btns="status_btn" :active_status="orderStatus" :sync_status="syncState[order.sync_state]" @changeStatus="changeStatus" @resyncOrder="resyncOrder">
                  <template #dialog v-if="orderStatus == 'NEW'">
                    <ButtonDialog :btn="status_rules.COOKING" label="Подтверждение заказа" @onSubmit="confirmOrder"/>
                  </template>
                </Buttons>
              </div>
          </v-banner>
        </template>

        <template #scroller>
            <h3><T>Информация о заказе</T></h3>

          <v-banner v-if="order.sync_state == 'ERR'" dark :color="syncState[order.sync_state].color" :icon="syncState[order.sync_state].icon">
            {{ order.sync_err }}
            <template v-slot:actions>
              <v-btn small @click="resyncOrder">
                <v-icon>mdi-sync</v-icon>
              </v-btn>
            </template>
          </v-banner>
          <v-row>
            <v-col>
              <InfoField :label="$t('Тип заказа')" dense>
                {{ orderType }} 
              </InfoField>
              <InfoField :label="$t('ФИО гостя')" dense>
                {{ order.guest.name }}
              </InfoField> 
              <InfoField :label="$t('Телефон')" dense>
                <PhoneFormatter v-model="order.phone.number"/>
              </InfoField>
              <InfoField :label="$t('EMail')" dense v-if="order.guest.email">
                <PhoneFormatter v-model="order.guest.email"/>
              </InfoField>
            </v-col>
            <v-col>
              <InfoField :label="order.order_type == 'DELIVERY' ? $t('Дата и время доставки') : $t('Дата и время визита гостя')" dense>
                {{ date }} {{ time }} 
              </InfoField>
              <InfoField :label=" order.rk_discount <= 0 ? $t('Скидка') : $t('Наценка')" dense>
                {{ order.rk_discount ?  Math.abs(order.rk_discount).toFixed(2) : $t('Нет')}}
              </InfoField>
              <InfoField :label="$t('Итог по заказу')" dense>
                {{ order.rk_sum.toFixed(2) }}
              </InfoField>
              <InfoField :label="$t('Тип оплаты')" dense>
                {{ $t(paymentType[order.payment_type]) }} 
              </InfoField>
            </v-col>
          </v-row>
          <v-row v-if="order.comment">
            <v-col>
              <InfoField :label="$t('Комментарий к заказу')" dense>
                {{ order.comment }}
              </InfoField>
            </v-col>
          </v-row>
          <div v-if="order.order_type == 'DELIVERY'">
            <h3 class="pt-3"><T>Информация о доставке</T></h3>
            <v-row>
              <v-col>
                <InfoField :label="$t('Адрес доставки')" dense>
                  {{ order.address.value }}
                </InfoField>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <InfoField :label="$t('Зона доставки')" dense>
                  {{ deliveryZone.name }}
                </InfoField>
                <InfoField :label="$t('Стоимость доставки')" dense>
                  {{ deliverySum.toFixed(2) }}
                </InfoField>
              </v-col>
              <v-col>
                <Map style="max-height: 400px; height: 100%; min-height: 245px; flex-grow: 1.5" :center="mapCenter" :zoom="15">
                  <LMarker :lat-lng="mapCenter" />
                  <LPolygon :lat-lngs="deliveryZone.polygon" :color="idxToColor(1)" :fillColor="idxToColor(2)" />
                </Map>
              </v-col>
            </v-row>
          </div>
          
          <v-expansion-panels class="my-4" v-model="panels">
            <v-expansion-panel >
              <v-expansion-panel-header :color="status_rules[orderStatus].color" style="color: white" >
                <T>Содержимое заказа</T>
                <template #actions>
                  <v-icon color="white">
                    $expand
                  </v-icon>
                </template>
                  <!-- <div>
                   <v-btn @click.stop="" text icon small color="white"><v-icon>mdi-pen</v-icon></v-btn>

                  </div>

                </template> -->
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div v-if="loading_order" class="d-flex flex-column align-center" style="height:100px" key="order_items">
                  <v-progress-circular size="45" indeterminate color="primary" />
                  <span>Загрузка содержимого заказа...</span>
                </div>
                <OrderTable class="mt-3" v-else 
                  :order="order_content"
                  :payment_type="order.payment_type"
                  :deliveryDishId="$store.getters.references.dish_delivery_ref[0].value"
                  :deliverySum="deliverySum">
                </OrderTable>
                
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

        </template>
      </ScrollerHandler>

      <div v-else class="d-flex justify-center align-center fill-height">
        <div class="text-center">
            <v-icon x-large style="transform: scale(2)">mdi-clipboard-off-outline</v-icon>
            <h3 class="mt-5"><T>Запрошенный заказ найден в текущей смене доставки.</T></h3>
            <p><T>Выберите другой заказ, или создайте новый.</T></p>
        </div>
      </div>
</template>

<script>
import InfoField from '@/components/common/InfoField.vue'
import PhoneFormatter from '@/components/common/PhoneFormatter.vue'
import Map from '@/components/common/Map.vue'
import Buttons from '../components/common/Buttons.vue'
import { LMarker, LPolygon } from 'vue2-leaflet'
import ScrollerHandler from '@/components/scroller_handler'

import { SyncStatus } from '@/helpers/status_helper.js'
import ButtonDialog from '../components/common/ButtonDialog.vue'
import OrderTable from '../components/common/OrderTable.vue'

export default {
  data: () => ({
    syncState: SyncStatus,
    loading_order: true,
    paymentType:{
      CARD: 'Картой при получении',
      CASH: 'Наличный',
      ONLINE: 'Картой онлайн'
    },
    panels: [],
    map_render: false,
    order_content: undefined,
    deliverySum: 0
  }),
  computed: {
    orderId() {
      return this.$route.params.orderId
    },
    order(){
      return this.$store.getters.orderById(this.orderId)
    },
    orderStatus(){
      return this.order.status
    },
    status_rules(){
      return this.$store.getters.status_dict
    },
    orderType(){
      return this.order.order_type.toLowerCase() == 'delivery' ? this.$t('Доставка') : this.$t('Самовывоз')
    },
    date(){
      let date = new Date(this.order.deliver_at)
      let day = (''+date.getDate()).length < 2 ?  `0${date.getDate()}` : date.getDate() 
      let month = (''+(date.getMonth() + 1)).length < 2 ? `0${date.getMonth()+1}` : date.getMonth()+1  
      let year = date.getFullYear()
      return `${day}.${month}.${year}`
    },
    time(){
      let time = new Date(this.order.deliver_at)
      let hours = (''+time.getHours()).length < 2 ? `0${time.getHours()}` : time.getHours()
      let minutes = (''+time.getMinutes()).length < 2 ? `0${time.getMinutes()}` : time.getMinutes()
      return `${hours}:${minutes}`
    },
    geocoding(){
      return this.$store.getters.local_refs.geocoding
    },
    deliveryZone(){
      return this.geocoding.zones[this.order.delivery_zone]
    },
    mapCenter(){
      if (this.order.address_extension) {
        return {
          lat: this.order.address_extension.lat,
          lon: this.order.address_extension.lon
        }
      } else {
        return this.geocoding.restaurant_address.coordinates
      }
    },
    status_btn(){
      return this.status_rules[this.orderStatus].rule.map((item)=>{
        return JSON.parse(JSON.stringify(this.status_rules[item]))
      })
    }
  },
  methods:{
    idxToColor(idx) {
      let colors = this.$store.getters.zone_colors
      return colors[idx % colors.length ]
    },
    async getSumDelivery() {
      const deliveryDishId = this.$store.getters.references.dish_delivery_ref[0].value

      // Загружаем содержимое заказа
      this.order_content = await this.$store.dispatch('getOrderContentByID', this.orderId)

      // Ищем item с нужным id
      const deliveryItem = this.order_content.items.find(item => item.id === deliveryDishId)

      // Устанавливаем сумму доставки
      if (deliveryItem) {
        if (deliveryItem.sum !== 0) {
          // если есть и сумма ненулевая
          this.deliverySum = deliveryItem.sum
        } else {
          // есть, но сумма == 0
          this.deliverySum = this.geocoding.zones[this.order.delivery_zone].price_delivery
        }
      } else {
        // нет item — ноль
        this.deliverySum = 0
      }
    },

    async changeStatus(status){
      await this.$store.dispatch('changeStatus', {
        order_id: this.orderId, 
        new_status: status,
        operator: this.$store.getters.user.fullname
      })
    },
    async confirmOrder(){
      await this.$store.dispatch('confirmOrder', {order_id: this.orderId})
    },
    async resyncOrder(){
      this.$store.dispatch('resyncOrder', {order_id: this.orderId})
    },
    async open_order_content(){
      this.loading_order = true
      this.order_content = await this.$store.dispatch('getOrderContentByID', this.orderId)
      this.loading_order = false
    }
  },
  async mounted(){
    if(!this.$store.getters.orders.length){
      await this.$store.dispatch('getOrders')
    }
    while (!this.$store.getters.references?.dish_delivery_ref?.length) {
      await new Promise(resolve => setTimeout(resolve, 100)) // ждём 100мс
    }

    await this.getSumDelivery()

  },
  watch:{
    panels(val){
      if(val == 0){
        this.open_order_content()
      }
    }
  },
  components:{
    InfoField,
    PhoneFormatter,
    Map,
    Buttons,
    LMarker,
    LPolygon,
    ScrollerHandler,
    ButtonDialog, 
    OrderTable
}
}
</script>